var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from "mobx";
import { BaseDialogState } from "@/app/UIComponents/BaseDialog";
export class MemberDialogState {
    constructor() {
        this.selectedids = new Set();
        this.filterstrig = "";
        this.dialogState = new BaseDialogState();
        makeObservable(this);
        this.dialogState.setHeaderLabel("Members");
        this.dialogState.setOkLabel("Done");
        this.dialogState.onOk = () => this.done();
    }
    done() {
        var _a;
        (_a = this.donecb) === null || _a === void 0 ? void 0 : _a.call(this, Array.from(this.selectedids));
        this.setOpen(false);
    }
    setSelId(id, bol) {
        if (bol) {
            this.selectedids.add(id);
        }
        else {
            this.selectedids.delete(id);
        }
    }
    setFilterString(str) {
        this.filterstrig = str;
    }
    setOpen(open) {
        this.dialogState.setOpen(open);
        if (!open) {
            this.selectedids.clear();
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Set)
], MemberDialogState.prototype, "selectedids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MemberDialogState.prototype, "filterstrig", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], MemberDialogState.prototype, "setSelId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MemberDialogState.prototype, "setFilterString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MemberDialogState.prototype, "setOpen", null);
